<div class="rbp">

  <!-- ── Header ── -->
  <div class="rbp__header">
    <div class="rbp__header-left">
      <div class="rbp__header-icon-badge">
        <i class="pi pi-receipt rbp__header-icon"></i>
      </div>
      <div class="rbp__header-text-group">
        <span class="rbp__header-title">Current Bill</span>
        <!-- <span *ngIf="products.length > 0" class="rbp__header-badge">{{ uniqueItemsCount || products.length }} items</span> -->
      </div>
    </div>

    <div class="rbp__header-actions">
      <button
        *ngIf="products.length > 0"
        type="button"
        class="rbp__header-hold-btn"
        (click)="holdReceiptClicked.emit()"
        title="Hold Receipt (F4)"
      >
        <i class="pi pi-pause"></i>
      </button>

      <button
        *ngIf="products.length > 0"
        class="rbp__clear-all-btn"
        (click)="cancelBillClicked.emit()"
        title="Clear all items"
      >
        <i class="pi pi-trash"></i>
        Clear All
      </button>
    </div>
  </div>

  <!-- ── Product-wise Discount Toggle Bar ── -->
  <div class="rbp__discount-toggle-bar" *ngIf="isSalesDiscountEditEnabled && !isExchangeOrder">
    <span class="rbp__discount-toggle-title">Product wise discount</span>
    <div class="rbp__discount-mode-group">
      <button
        type="button"
        class="rbp__disc-mode-btn"
        [class.rbp__disc-mode-btn--active]="discountMode === 'percentage'"
        (click)="onProductDiscountToggle('percentage')"
        title="Switch to Percentage (%)"
      >
        %
      </button>
      <button
        type="button"
        class="rbp__disc-mode-btn"
        [class.rbp__disc-mode-btn--active]="discountMode === 'amount'"
        (click)="onProductDiscountToggle('amount')"
        title="Switch to Amount ({{ currencySymbol }})"
      >
        {{ currencySymbol }}
      </button>
    </div>
  </div>

  <!-- ── Items scroll area ── -->
  <div class="rbp__items-scroll">

    <!-- Empty state -->
    <div *ngIf="products.length === 0" class="rbp__empty">
      <div class="rbp__empty-badge">
        <i class="pi pi-shopping-cart rbp__empty-icon"></i>
      </div>
      <p class="rbp__empty-text">No items added yet</p>
      <p class="rbp__empty-hint">Click a menu item to add it</p>
    </div>

    <!-- Item rows -->
    <div *ngFor="let product of products" class="rbp__item">
      <!-- Body -->
      <div class="rbp__item-body">
        <!-- Name + remove -->
        <div class="rbp__item-row rbp__item-row--top">
          <span class="rbp__item-name" [title]="product.name">{{ product.name }}</span>
          <button
            class="rbp__item-remove"
            (click)="removeItemClicked.emit(product)"
            [attr.aria-label]="'Remove ' + product.name"
            title="Remove item"
          >
            <i class="pi pi-times"></i>
          </button>
        </div>

        <!-- Unit price + Direct Product-wise Discount Input -->
        <div class="rbp__item-row rbp__item-row--meta">
          <span class="rbp__item-unit-price">
            {{ currencySymbol }}{{ getDisplayPrice(product) | number:'1.2-2' }}
            <span *ngIf="product.unit"> / {{ product.unit }}</span>
          </span>

          <!-- Direct Item Discount Input Box -->
          <div class="rbp__item-disc-pill" *ngIf="isSalesDiscountEditEnabled && !isExchangeOrder">
            <span class="rbp__item-disc-label">Disc:</span>
            <input
              *ngIf="!isTouchKeypadEnabled"
              type="number"
              class="rbp__item-disc-input"
              [value]="product.discount === 0 ? '' : product.discount"
              (input)="onItemDiscountInput($event, product)"
              [placeholder]="discountMode === 'percentage' ? '0%' : '₹0'"
              min="0"
              [max]="discountMode === 'percentage' ? 100 : getDisplayPrice(product)"
            />
            <input
              *ngIf="isTouchKeypadEnabled"
              type="text"
              inputmode="none"
              readonly
              class="rbp__item-disc-input"
              [value]="product.discount === 0 ? '' : product.discount"
              (click)="openItemDiscountKeypad(product)"
              [placeholder]="discountMode === 'percentage' ? '0%' : '₹0'"
            />
            <span class="rbp__item-disc-unit">{{ discountMode === 'percentage' ? '%' : currencySymbol }}</span>
          </div>
        </div>

        <!-- Qty stepper + line total -->
        <div class="rbp__item-row rbp__item-row--bottom">
          <div class="rbp__qty">
            <button
              class="rbp__qty-btn rbp__qty-btn--minus"
              (click)="decreaseQtyClicked.emit(product)"
              [disabled]="getProductQty(product) <= 1"
              title="Decrease quantity"
            >
              <i class="pi pi-minus"></i>
            </button>
            <span class="rbp__qty-val">{{ getProductQty(product) }}</span>
            <button
              class="rbp__qty-btn rbp__qty-btn--plus"
              (click)="increaseQtyClicked.emit(product)"
              [disabled]="product.product_type !== 'Non Stock' && getProductQty(product) >= (product.quantity || 9999)"
              title="Increase quantity"
            >
              <i class="pi pi-plus"></i>
            </button>
          </div>
          <span class="rbp__item-line-total">
            {{ currencySymbol }}{{ getLineTotal(product) | number:'1.2-2' }}
          </span>
        </div>
      </div>

    </div>
  </div>

  <!-- ── Totals (only when items exist) ── -->
  <div class="rbp__totals">

    <!-- Sub Total -->
    <div class="rbp__total-row">
      <span class="rbp__total-label">Sub Total</span>
      <span class="rbp__total-val">{{ currencySymbol }}{{ subtotal | number:'1.2-2' }}</span>
    </div>

    <!-- Discount — editable when enableOverAllDiscount, else show product discount -->
    <div class="rbp__total-row rbp__total-row--discount" *ngIf="enableOverAllDiscount && !isExchangeOrder && products.length > 0">
      <span class="rbp__total-label">Overall Discount</span>
      <div class="rbp__discount-group">
        <div class="rbp__overall-mode-toggle">
          <button
            type="button"
            class="rbp__overall-mode-btn"
            [class.rbp__overall-mode-btn--active]="overAllDiscountMode === 'percentage'"
            (click)="onOverAllDiscountModeToggle('percentage')"
            title="Percentage (%)"
          >
            %
          </button>
          <button
            type="button"
            class="rbp__overall-mode-btn"
            [class.rbp__overall-mode-btn--active]="overAllDiscountMode === 'amount'"
            (click)="onOverAllDiscountModeToggle('amount')"
            title="Amount ({{ currencySymbol }})"
          >
            {{ currencySymbol }}
          </button>
        </div>
        <input
          *ngIf="!isTouchKeypadEnabled"
          type="number"
          class="rbp__discount-input"
          [value]="discountRawValue"
          (input)="onDiscountInput($event)"
          (blur)="onDiscountBlur()"
          [placeholder]="overAllDiscountMode === 'percentage' ? '0 %' : '0.00'"
          [max]="overAllDiscountMode === 'percentage' ? 100 : subtotalAfterLineDiscount"
          min="0"
        />
        <input
          *ngIf="isTouchKeypadEnabled"
          type="text"
          inputmode="none"
          readonly
          class="rbp__discount-input"
          [value]="discountRawValue"
          (click)="openOverallDiscountKeypad()"
          [placeholder]="overAllDiscountMode === 'percentage' ? '0 %' : '0.00'"
        />
      </div>
    </div>
    <div class="rbp__total-row" *ngIf="!enableOverAllDiscount">
      <span class="rbp__total-label">Discount</span>
      <span class="rbp__total-val" [class.rbp__val--green]="productDiscount > 0">
        {{ productDiscount > 0 ? '-' : '' }}{{ currencySymbol }}{{ productDiscount | number:'1.2-2' }}
      </span>
    </div>
    <div class="rbp__total-row" *ngIf="enableOverAllDiscount && !isExchangeOrder && overAllDiscountAmount > 0">
      <span class="rbp__total-label rbp__total-label--sub">Overall Discount Applied</span>
      <span class="rbp__total-val rbp__val--green">-{{ currencySymbol }}{{ overAllDiscountAmount | number:'1.2-2' }}</span>
    </div>

    <!-- Tax -->
    <div *ngIf="isInterStateTaxOrder && igst > 0" class="rbp__total-row">
      <span class="rbp__total-label">IGST</span>
      <span class="rbp__total-val">{{ currencySymbol }}{{ igst | number:'1.2-2' }}</span>
    </div>
    <div *ngIf="!isInterStateTaxOrder && (cgst > 0 || sgst > 0)" class="rbp__total-row">
      <span class="rbp__total-label">Tax ({{ (cgst + sgst) | number:'1.0-0' }}%)</span>
      <span class="rbp__total-val">{{ currencySymbol }}{{ (cgst + sgst) | number:'1.2-2' }}</span>
    </div>
    <div *ngIf="!isInterStateTaxOrder && cgst === 0 && sgst === 0 && taxAmount > 0" class="rbp__total-row">
      <span class="rbp__total-label">Tax</span>
      <span class="rbp__total-val">{{ currencySymbol }}{{ taxAmount | number:'1.2-2' }}</span>
    </div>

    <!-- Round Off -->
    <div class="rbp__total-row" *ngIf="roundOffAmount !== 0">
      <span class="rbp__total-label">Round Off</span>
      <span class="rbp__total-val"
        [class.rbp__val--green]="roundOffAmount > 0"
        [class.rbp__val--red]="roundOffAmount < 0"
      >
        {{ currencySymbol }}{{ roundOffAmount | number:'1.2-2' }}
      </span>
    </div>

    <!-- Strong Visual Total Card -->
    <div class="rbp__net-card">
      <div class="rbp__net-info">
        <span class="rbp__net-label">Total Amount</span>
        <!-- <span class="rbp__net-subtext">Tax & Charges included</span> -->
      </div>
      <span class="rbp__net-val">{{ currencySymbol }}{{ roundedTotal | number:'1.2-2' }}</span>
    </div>

  </div>

  <!-- ── Action buttons ── -->
  <div class="rbp__footer-area">
    <div class="rbp__actions">
      
      <button class="rbp__btn rbp__btn--cancel" (click)="cancelBillClicked.emit()" title="Cancel Bill (F5)">
        <i class="pi pi-times"></i>
        <span>Cancel</span>
      </button>
      <button
        class="rbp__btn rbp__btn--pay"
        (click)="processOrderClicked.emit()"
        [disabled]="
          isQuotationMode
            ? !canCompleteQuotation || isProcessingQuotation
            : roundedTotal <= 0 || hasPendingVariantSelection || isOrderBlocked
        "
      >
        <i class="pi pi-credit-card"></i>
        <div class="rbp__btn-pay-inner">
          <span class="rbp__btn-pay-label">{{ getProcessButtonText() }}</span>
        </div>
      </button>
    </div>
  </div>

</div>

<!-- ── Touch numeric keypad for discount entry ── -->
<app-numeric-keypad-dialog
  [visible]="keypadOpen"
  (visibleChange)="keypadOpen = $event"
  [label]="keypadLabel"
  [subLabel]="keypadSubLabel"
  [unit]="keypadUnit"
  [initialValue]="keypadInitialValue"
  [maxValue]="keypadMaxValue"
  (confirm)="onKeypadConfirm($event)"
  (cancel)="onKeypadCancel()"
></app-numeric-keypad-dialog>
